(ns ballot-scout-v2-frontend.disposition-manager.events
  (:require
   [ajax.core :as ajax]
   [ajax.edn :as ajax.edn]
   [ballot-scout-v2-frontend.api-urls :as urls]
   [ballot-scout-v2-frontend.db :as db]
   [ballot-scout-v2-frontend.disposition-manager.common :refer [default-search-state]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.util :as util]
   [clojure.set :as set]
   [day8.re-frame.http-fx]
   [goog.labs.format.csv :as csv]
   [re-frame.core :as rf]))

(def phase-mappings {"column-mapping"            :disposition-phase/match-fields
                     "ready-to-start"            :disposition-phase/preview
                     "block-due-to-invalid-rows" :disposition-phase/preview
                     "terminated-by-user"        :disposition-phase/canceled
                     "processing"                :disposition-phase/processing
                     "completed"                 :disposition-phase/final
                     "failed"                    :disposition-phase/final})

(def ns-key :disposition-manager)

(rf/reg-event-fx
 ::fetch-disposition
 (fn [{:keys [db]} [_ dispo-id]]
   {:db (assoc-in db [ns-key :fetching-disposition :status] :fetching)
    ::events/ajax {:method :get
                   :uri (urls/disposition-by-id dispo-id)
                   :format (ajax.edn/edn-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::fetch-disposition-success dispo-id]
                   :on-failure [::fetch-disposition-failure dispo-id]}}))

(rf/reg-event-fx
 ::fetch-disposition-success
 (fn [{:keys [db]} [_ dispo-id response]]
   {:db (-> db
            (db/add-entity response)
            (assoc-in [ns-key :fetching-disposition :status] :success))
    :dispatch [::request-helpers/clear-failed-request [::fetch-disposition dispo-id]]}))

(rf/reg-event-fx
 ::fetch-disposition-failure
 (fn [{:keys [db]} [_ dispo-id response]]
   {:db (assoc-in db [ns-key :fetching-disposition :status] :errored)
    :dispatch [::request-helpers/request-failed [::fetch-disposition dispo-id] response]}))

(rf/reg-event-fx
 ::cancel-disposition
 (fn [_ [_ dispo-id]]
   {::events/ajax {:method :post
                   :uri (urls/cancel-disposition dispo-id)
                   :format (ajax.edn/edn-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::cancel-disposition-success dispo-id]
                   :on-failure [::cancel-disposition-failure dispo-id]}}))

(rf/reg-event-fx
 ::cancel-disposition-success
 (fn [_ [_ dispo-id _]]
   {:dispatch [::request-helpers/clear-failed-request [::cancel-disposition dispo-id]]}))

(rf/reg-event-fx
 ::cancel-disposition-failure
 (fn [_ [_ dispo-id response]]
   {:dispatch [::request-helpers/request-failed [::cancel-disposition dispo-id] response]}))

(rf/reg-event-db
 ::clear
 (fn [db [_]]
   (dissoc db ns-key)))

(rf/reg-event-fx
 ::upload-for-jurisdiction
 (fn [{:keys [db]} [_ jurisdiction-id election-slug blob]]
   {:db (assoc-in db [ns-key :upload] {:status :uploading})
    ::events/ajax {:method :post
                   :body (doto (js/FormData.) (.append "file" blob))
                   :uri (urls/new-disposition-upload-for-jurisdiction jurisdiction-id election-slug)
                   :format (ajax/url-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::upload-for-jurisdiction-success jurisdiction-id election-slug (hash blob)]
                   :on-failure [::upload-for-jurisdiction-failure jurisdiction-id election-slug (hash blob)]}}))

(rf/reg-event-fx
 ::upload-for-partner
 (fn [{:keys [db]} [_ partner-id election-slug blob]]
   {:db (assoc-in db [ns-key :upload] {:status :uploading})
    ::events/ajax {:method :post
                   :body (doto (js/FormData.) (.append "file" blob))
                   :uri (urls/new-disposition-upload-for-partner partner-id election-slug)
                   :format (ajax/url-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::upload-for-partner-success partner-id election-slug (hash blob)]
                   :on-failure [::upload-for-partner-failure partner-id election-slug (hash blob)]}}))

(rf/reg-event-fx
 ::upload-for-jurisdiction-success
 (fn [{:keys [db]} [_ jurisdiction-id election-slug blob-hash response]]
   {:db (db/add-entity db response)
    :dispatch-n [[::request-helpers/clear-failed-request
                  [::upload-for-jurisdiction jurisdiction-id election-slug blob-hash]]
                 [:ballot-scout-v2-frontend.routes/navigate
                  :ballot-scout-v2-frontend.routes/jurisdiction-disposition-manager
                  {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])
                   :disposition-id (:disposition/id response)}]]}))

(rf/reg-event-fx
 ::upload-for-partner-success
 (fn [{:keys [db]} [_ partner-id election-slug blob-hash response]]
   {:db (db/add-entity db response)
    :dispatch-n [[::request-helpers/clear-failed-request
                  [::upload-for-partner partner-id election-slug blob-hash]]
                 [:ballot-scout-v2-frontend.routes/navigate
                  :ballot-scout-v2-frontend.routes/partner-disposition-manager
                  {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])
                   :disposition-id (:disposition/id response)}]]}))

(rf/reg-event-fx
 ::upload-for-jurisdiction-failure
 (fn [{:keys [db]} [_ jurisdiction-id election-slug blob-hash response]]
   {:db (-> db
            (assoc-in [ns-key :upload :status] :errored)
            (assoc-in [ns-key :upload :error-response] (:status-text response)))
    :dispatch [::request-helpers/request-failed
               [::upload-for-jurisdiction jurisdiction-id election-slug blob-hash] response]}))

(rf/reg-event-fx
 ::upload-for-partner-failure
 (fn [{:keys [db]} [_ partner-id election-slug blob-hash response]]
   {:db (-> db
            (assoc-in [ns-key :upload :status] :errored)
            (assoc-in [ns-key :upload :error-response] (:status-text response)))
    :dispatch [::request-helpers/request-failed
               [::upload-for-partner partner-id election-slug blob-hash] response]}))

(defn assoc-header-state [db dispo-id state]
  (update-in db [ns-key :data dispo-id :header-state] merge state))

(defn parse-csv-line [s]
  (first (csv/parse s)))

(rf/reg-event-db
 ::set-headers
 (fn [db [_ dispo-id headers]]
   (assoc-header-state db dispo-id {:status :fetched :headers headers})))

(rf/reg-event-fx
 ::fetch-headers
 (fn [{:keys [db]} [_ {:disposition/keys [id original-file-url]}]]
   {:db (assoc-header-state db id {:status :fetching})
    ::events/fetch-lines {:url original-file-url
                          :limit 1
                          :on-line #(rf/dispatch [::set-headers id (parse-csv-line %)])}}))

(rf/reg-event-fx
 ::post-column-mapping
 (fn [{:keys [db]} [_ {:disposition/keys [id] :as dispo} column-mapping]]
   {:db (assoc-header-state db id {:status :setting-column-mapping})
    :dispatch [::poll-for-current-disposition #(not= "column-mapping" (:disposition/phase %))]
    ::events/ajax {:method :post
                   :params (->> column-mapping
                                (remove (fn [[_ v]] (string? v)))
                                (into {})
                                set/map-invert)
                   :uri (urls/set-disposition-column-mapping id)
                   :format (ajax.edn/edn-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::post-column-mapping-success dispo column-mapping]
                   :on-failure [::post-column-mapping-failure dispo column-mapping]}}))

(rf/reg-event-fx
 ::post-column-mapping-success
 (fn [{:keys [db]} [_ dispo column-mapping response]]
   {:db (db/add-entity db response)
    :dispatch [::request-helpers/clear-failed-request [::post-column-mapping dispo column-mapping]]
    :interval {:id ::poll-disposition :action :stop}}))

(rf/reg-event-fx
 ::post-column-mapping-failure
 (fn [{:keys [db]} [_ dispo column-mapping response]]
   {:db (-> db
            (assoc-in [ns-key :disposition-phase/match-fields :status] :errored)
            (assoc-in [ns-key :disposition-phase/match-fields :error-response] (:status-text response)))
    :dispatch [::request-helpers/request-failed [::post-column-mapping dispo column-mapping] response]
    :interval {:id ::poll-disposition :action :stop}}))

(rf/reg-event-fx
 ::start-disposition
 (fn [{:keys [db]} [_ {:disposition/keys [id] :as dispo}]]
   {:db (assoc-in db [ns-key :data id :ready-state :status] :starting)
    :dispatch [::poll-for-completed-disposition]
    ::events/ajax {:method :post
                   :uri (urls/start-disposition id)
                   :format (ajax.edn/edn-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::start-disposition-success dispo]
                   :on-failure [::start-disposition-failure dispo]}}))

(rf/reg-event-fx
 ::start-disposition-success
 (fn [{:keys [db]} [_ dispo response]]
   {:db (db/add-entity db response)
    :dispatch [::request-helpers/clear-failed-request [::start-disposition dispo]]}))

(rf/reg-event-fx
 ::start-disposition-failure
 (fn [{:keys [db]} [_ dispo response]]
   {:db (-> db
            (assoc-in [ns-key :disposition-phase/start :status] :errored)
            (assoc-in [ns-key :disposition-phase/start :error-response] (:status-text response)))
    :dispatch [::request-helpers/request-failed [::start-disposition dispo] response]}))

(rf/reg-event-fx
 ::poll-for-disposition-query
 (fn [_ [_ dispo-id stop-fn]]
   {::events/ajax {:method :get
                   :uri (urls/disposition-by-id dispo-id)
                   :format (ajax.edn/edn-request-format)
                   :response-format (ajax.edn/edn-response-format)
                   :on-success [::poll-for-disposition-query-success dispo-id stop-fn]
                   :on-failure [::poll-for-disposition-query-failure dispo-id stop-fn]}}))

(rf/reg-event-fx
 ::poll-for-disposition-query-success
 (fn [{:keys [db]} [_ dispo-id stop-fn response]]
   (merge
    {:db (db/add-entity db response)
     :dispatch [::request-helpers/clear-failed-request [::poll-for-disposition-query dispo-id stop-fn]]}
    (when (stop-fn response)
      {:interval {:id ::poll-disposition :action :stop}}))))

(rf/reg-event-fx
 ::poll-for-disposition-query-failure
 (fn [_ dispo-id stop-fn response]
   {:interval {:id ::poll-disposition :action :stop}
    :dispatch [::request-helpers/request-failed [::poll-for-disposition-query dispo-id stop-fn] response]}))

(rf/reg-event-fx
 ::poll-for-current-disposition
 (fn [{:keys [db]} [_ stop-fn]]
   (when-let [current-dispo-id (util/->int (get-in db [:current-route :path-params :disposition-id]))]
     {:interval {:dispatch [::poll-for-disposition-query current-dispo-id stop-fn]
                 :action :start
                 :ms 5000
                 :id ::poll-disposition}})))

(rf/reg-event-fx
 ::poll-for-completed-disposition
 (fn [_ _]
   {:dispatch [::poll-for-current-disposition #(contains? #{"completed" "failed"} (:disposition/phase %))]}))

(defn fetch-disposition-list-for-route [db route uri on-success on-fail]
  (let [query-params (merge default-search-state (:query-params route))]
    {:db (assoc-in db [ns-key :list-state :status] :fetching)
     ::events/ajax {:method :get
                    :uri uri
                    :params query-params
                    :format (ajax.edn/edn-request-format)
                    :response-format (ajax.edn/edn-response-format)
                    :on-success on-success
                    :on-failure on-fail}}))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-jurisdiction-route
 (fn [{:keys [db]} [_ route]]
   (fetch-disposition-list-for-route db
                                     route
                                     (urls/dispositions-list-for-jurisdiction
                                      (get-in route [:path-params :jurisdiction-slug])
                                      (get-in route [:path-params :election-slug]))
                                     [::fetch-dispositions-list-for-jurisdiction-route-success route]
                                     [::fetch-dispositions-list-for-jurisdiction-route-failure route])))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-partner-route
 (fn [{:keys [db]} [_ route]]
   (fetch-disposition-list-for-route db
                                     route
                                     (urls/dispositions-list-for-partner
                                      (get-in route [:path-params :partner-slug])
                                      (get-in route [:path-params :election-slug]))
                                     [::fetch-dispositions-list-for-partner-route-success route]
                                     [::fetch-dispositions-list-for-partner-route-failure route])))

(defn disposition-list-success-db-fx [db response]
  (-> db
      (assoc-in [ns-key :list-state :status] :success)
      (assoc-in [ns-key :list-state :data] response)))

(defn disposition-list-fail-db-fx [db response]
  (-> db
      (assoc-in [ns-key :list-state :status] :errored)
      (assoc-in [ns-key :list-state :error-response] (:status-text response))))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-jurisdiction-route-success
 (fn [{:keys [db]} [_ route response]]
   {:db (disposition-list-success-db-fx db response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-dispositions-list-for-jurisdiction-route route]]}))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-jurisdiction-route-failure
 (fn [{:keys [db]} [_ route response]]
   {:db (disposition-list-fail-db-fx db response)
    :dispatch [::request-helpers/request-failed [::fetch-dispositions-list-for-jurisdiction-route route] response]}))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-partner-route-success
 (fn [{:keys [db]} [_ route response]]
   {:db (disposition-list-success-db-fx db response)
    :dispatch [::request-helpers/clear-failed-request [::fetch-dispositions-list-for-partner-route route]]}))

(rf/reg-event-fx
 ::fetch-dispositions-list-for-partner-route-failure
 (fn [{:keys [db]} [_ route response]]
   {:db (disposition-list-fail-db-fx db response)
    :dispatch [::request-helpers/request-failed [::fetch-dispositions-list-for-partner-route route] response]}))

(rf/reg-event-db
 ::clear-disposition-state
 (fn [db _]
   (assoc-in db [ns-key :list-state] nil)))
